export default () => ({
  show: false,
  thumbWidth: null,
  galleryWidth: null,
  mousePosition: 0,
  scrollPos: 0,

  thumbScroll(e) {
    this.mousePosition = e.clientX;
    document.onmouseup = this.closeDragElement;
    const initPos = this.scrollPos
    document.onmousemove = (event) => {
      this.dragThumb(event, this.mousePosition, initPos);
    };
  },

  closeDragElement() {
    document.onmouseup = null;
    document.onmousemove = null;
  },

  dragThumb(e, mousePosition, initPos) {
    const dir = mousePosition > e.clientX ? -1 : 1;
    const mouseMove = Math.abs(mousePosition - e.clientX);
    let pos = (mouseMove / this.$refs.scrollbar.offsetWidth * 100 * dir) + initPos;
    this.scrollPos = Math.min(Math.max(pos, 0), 100 - this.thumbWidth);
    this.scrollGallery();
  },

  scrollGallery() {
    this.$refs.gallery.scrollLeft = (this.galleryWidth) * this.scrollPos / 100;
  },

  addPercent(num) {
    return num + '%';
  },

  mouseScroll(e) {
    this.scrollPos = e.target.scrollLeft / (this.galleryWidth)* 100;
  },

  init() {
    this.galleryWidth = this.$refs.gallery.scrollWidth - parseInt(window.getComputedStyle(this.$refs.gallery).paddingRight);
    const containerStyle = window.getComputedStyle(this.$el);
    const containerWidth = this.$el.offsetWidth - (parseInt(containerStyle.paddingLeft.slice(0, -2)) + parseInt(containerStyle.paddingRight.slice(0, -2)));
    if (this.galleryWidth > containerWidth) {
      this.show = true;
      this.thumbWidth = containerWidth/this.galleryWidth * 100;
    }
  },
});
